var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-skeleton-wrapper',{attrs:{"loading":_vm.loading},scopedSlots:_vm._u([{key:"loading",fn:function(){return [(_vm.label)?_c('label',{staticClass:"fs-14 ce-radio-buttons--buttons-label"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('b-skeleton',{attrs:{"type":"input"}})]},proxy:true}])},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }